import { render } from "./affiliate-assessment.vue?vue&type=template&id=114a2b2c&scoped=true&ts=true"
import script from "./affiliate-assessment.vue?vue&type=script&lang=ts"
export * from "./affiliate-assessment.vue?vue&type=script&lang=ts"

import "./affiliate-assessment.vue?vue&type=style&index=0&id=114a2b2c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-114a2b2c"]])

export default __exports__